import { defineSlotRecipe as e } from "@pandacss/dev";
import { anatomy as o } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/number-input/dist/index.mjs";
const r = e({
  className: "numberInput",
  slots: [...o.keys(), "flexContainer"],
  base: {
    root: {
      colorPalette: "accent",
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    control: {
      backgroundColor: "neutral.50",
      borderRadius: "2",
      borderWidth: "1px",
      width: "40px",
      display: "grid",
      divideX: "1px",
      gridTemplateColumns: "1fr 32px",
      gridTemplateRows: "1fr 1fr",
      overflow: "hidden",
      transitionDuration: "normal",
      transitionProperty: "border-color, box-shadow",
      transitionTimingFunction: "default"
    },
    input: {
      background: "transparent",
      border: "none",
      gridRow: "2",
      outline: "none",
      width: "22px",
      textAlign: "center"
    },
    label: {
      color: "fg.default",
      fontWeight: "medium"
    },
    flexContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "3",
      alignItems: "center"
    }
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      md: {
        control: {
          padding: "2",
          h: "10",
          minW: "10",
          fontSize: "md"
        },
        label: {
          textStyle: "sm"
        }
      }
    }
  }
});
export {
  r as numberInput
};
